var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCePimage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CEPimage_svg__clip0_96_7675)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.694 29.872c-7.724-6.581-47.87-40.787-91.59-26.353C8.563 19.875 1.033 83.3.572 87.77c-3.322 32.175 7.615 73.974 38.275 92.456 3.542 2.136 11.053 6.193 35.128 9.882 48.906 7.493 88.98 13.637 109.963-5.904 31.712-29.539 14.481-112.815-34.244-154.332z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.349 19.44L70.541 16.045l-.406-.735-.94-.027a1.678 1.678 0 00-1.196.453 1.631 1.631 0 00-.512 1.154v151.998l109.842-6.113c3.488-.195 6.323-3.281 6.323-6.894V25.201c0-3.614-2.815-5.657-6.303-5.761z",
    fill: "#68000D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.539 18.471l-108.17-3.188a1.627 1.627 0 00-1.174.454 1.601 1.601 0 00-.487 1.153v151.998l109.841-6.113c3.488-.195 6.324-3.281 6.324-6.895V25.2c0-3.613-2.846-6.626-6.334-6.729z",
    fill: "url(#CEPimage_svg__paint0_linear_96_7675)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.912 134.424l-32.334.284V17.411l32.334.955v116.058z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.694 29.872l-82.207-2.13.06 81.489h23.056v63.69l59.178-3.658c1.462-.09 2.636-1.293 2.636-2.746V32.62a2.756 2.756 0 00-.8-1.92 2.804 2.804 0 00-1.923-.828z",
    fill: "#000",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.224 164.563c-2.685-4.544-6.08-11.946-4.72-20.239 2.375-14.467 16.552-15.364 23.774-32.644 5.824-13.937-.328-20.705 7.878-31.618 1.373-1.826 8.534-11.726 17.114-10.67 4.835.595 7.975 4.4 8.565 5.115 8.907 10.794 3.698 34.984-9.426 50.135-7.54 8.705-11.251 8.21-25.686 20.51a100.273 100.273 0 00-17.499 19.411z",
    fill: "url(#CEPimage_svg__paint1_linear_96_7675)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    fill: "#fff"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.832 170.979c-2.053-12.533-.444-22.091 4.773-28.407 2.555-3.093 5.045-4.376 7.681-5.734 2.829-1.457 5.755-2.965 8.855-6.922 3.012-3.845 3.542-6.646 4.213-10.193.605-3.195 1.357-7.171 4.182-13.161 2.476-5.251 4.656-8.096 6.58-10.607 2.08-2.718 3.724-4.863 4.965-9.056 2.029-6.853 1.531-14.461-1.481-22.614l.235-.085c3.027 8.203 3.526 15.867 1.481 22.768-1.254 4.238-2.91 6.4-5.007 9.137-1.916 2.497-4.088 5.335-6.552 10.562-2.814 5.961-3.56 9.917-4.162 13.102-.679 3.58-1.213 6.407-4.263 10.299-3.133 4-6.083 5.52-8.936 6.99-2.612 1.346-5.08 2.617-7.604 5.671-5.172 6.259-6.759 15.75-4.719 28.209l-.241.041z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.263 97.297l-.008-.165c-.009-.183-.985-18.263-9.522-22.636l.115-.22c8.219 4.21 9.527 20.832 9.647 22.678 8.96-3.148 14.265-8.99 17.145-13.35 3.137-4.75 4.146-8.805 4.155-8.846l.243.059c-.01.04-1.029 4.138-4.19 8.924-2.917 4.416-8.309 10.344-17.427 13.501l-.158.055z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.77 113.15c-.43 0-.667-.012-.678-.012l-.107-.006-.011-.106c-.908-9.277-7.585-20.432-7.653-20.544l.215-.127c.067.112 6.722 11.228 7.677 20.539.751.025 5.367.091 11.26-1.53 5.917-1.628 14.37-5.341 21.03-13.78l.197.151c-6.709 8.498-15.217 12.232-21.173 13.87-5.06 1.392-9.19 1.545-10.757 1.545zM139.883 136.506c-4.994 0-7.987-.784-8.047-.8l-.127-.034.041-.124c3.413-10.211-4.055-22.104-4.13-22.223l.211-.133c.074.12 7.544 12.013 4.198 22.307 1.345.322 13.131 2.833 28.731-3.492l.095.23c-8.447 3.424-15.788 4.269-20.972 4.269z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.694 155.886a68.088 68.088 0 0116.463-9.668c13.444-5.509 19.865-2.989 25.365-9.026 5.693-6.248 1.505-11.905 8.345-18.908.576-.588 7.93-7.924 15.041-5.693 4.975 1.561 7.159 6.965 8.184 9.501 3.979 9.844 2.754 25.207-7.627 33.282-9.845 7.657-22.951 4.912-27.113 4.012-7.303-1.579-9.153-4.277-16.566-5.667-9.018-1.688-16.939.305-22.092 2.167z",
    fill: "url(#CEPimage_svg__paint2_linear_96_7675)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    fill: "#fff"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.95 158.301l-.169-.206c8.157-6.582 16.283-9.917 24.154-9.917h.131c3.46.016 5.92.655 8.298 1.272 2.971.772 5.776 1.5 10.347 1.078 8.225-.76 15.115-3.893 19.401-8.815 6.637-7.63 7.558-19.911 2.347-31.289l.244-.109c5.253 11.471 4.316 23.864-2.389 31.571-4.331 4.979-11.283 8.143-19.577 8.909-4.617.426-7.445-.308-10.441-1.085-2.363-.614-4.806-1.249-8.232-1.264-7.84-.033-15.961 3.277-24.114 9.855z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.254 137.013l.005-.203c.169-6.99-4.331-12.058-8.135-15.079-4.133-3.281-8.356-4.922-8.398-4.938l.096-.247c.043.016 4.304 1.672 8.468 4.978 3.815 3.028 8.319 8.093 8.24 15.084 1.617-.722 13.033-6.157 13.308-15.713l.267.008c-.302 10.404-13.527 15.977-13.661 16.032l-.19.078z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.981 153.035a28.242 28.242 0 01-3.855-.261c-5.708-.788-9.142-3.085-9.176-3.108l-.108-.073.074-.109c3.818-5.827 2.818-11.949 1.309-16.06-1.642-4.467-4.221-7.592-4.251-7.623l.206-.169c.026.031 2.635 3.186 4.295 7.694 1.524 4.142 2.535 10.304-1.259 16.191.624.39 3.881 2.296 8.967 2.995 5.213.717 13.473.277 23.211-5.896l.144.22c-7.682 4.87-14.453 6.199-19.557 6.199z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.952 36.648l-105.96-4.543-.206-.45-1.435-.037a2.912 2.912 0 00-2.062.78c-.536.517-.893 1.228-.893 1.97v143.326c0 .759.362 1.485.92 2.004a2.845 2.845 0 002.095.742l1.15-.074.638-1.866 105.663-6.74c1.462-.091 2.771.734 2.771-.717V37.154c-.004-1.49-1.178-.468-2.681-.507z",
    fill: "#383838"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142.86 34.404L35.324 31.613c-.747-.02-1.538.261-2.073.78-.535.517-.905 1.228-.905 1.97v143.331c0 .759.378 1.485.936 2.005a2.856 2.856 0 002.103.741l107.561-6.649c1.462-.09 2.636-1.293 2.636-2.746V37.155a2.76 2.76 0 00-.799-1.923 2.802 2.802 0 00-1.923-.828z",
    fill: "url(#CEPimage_svg__paint3_linear_96_7675)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.073 63.8l-63.728-.46V45.581l63.728 1.127V63.8zM129.189 112.199l-75.27 1.718v-19.39l75.27-.904V112.2zM129.189 137.515l-75.27 2.907v-18.18l75.27-2.092v17.365z",
    fill: "#E2E2E2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.921 155.297l-4.832 21.64 10.957 15.055 54.102-3.609-60.227-33.086z",
    fill: "#000",
    opacity: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.429 187.078l-65.781 3.288-.789 1.662-.338.021c-.757.047-1.425-.515-1.538-1.298l-5.049-34.82c-.13-.901.507-1.702 1.381-1.738l.598-.009.37.188 66.262-1.656c.746-.03 1.346-.71 1.457.06l4.839 33.373c.131.888-.553.876-1.412.929z",
    fill: "url(#CEPimage_svg__paint4_linear_96_7675)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M162.863 166.759L96.977 170l-1.672-11.532 65.949-2.809 1.609 11.1z",
    fill: "url(#CEPimage_svg__paint5_linear_96_7675)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.073 169.5l-10.236.517-1.518-10.467 10.245-.454 1.509 10.404z",
    fill: "url(#CEPimage_svg__paint6_linear_96_7675)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M164.687 179.332l-10.106.572-1.508-10.404 10.113-.511 1.501 10.343z",
    fill: "url(#CEPimage_svg__paint7_linear_96_7675)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M169.161 187.903l-66.955 4.143c-.757.047-1.424-.514-1.538-1.298l-5.048-34.82c-.13-.901.518-1.72 1.394-1.755l67.163-2.699c.746-.03 1.396.529 1.507 1.299l4.839 33.373c.131.891-.5 1.703-1.362 1.757z",
    fill: "url(#CEPimage_svg__paint8_linear_96_7675)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M163.546 166.759L97.66 170l-1.672-11.532 65.948-2.809 1.61 11.1z",
    fill: "#D8D8D8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.73 195.603s6.306 2.862 6.408 3.316c.102.455-4.06-.161-5.76-.1-1.7.061-3.097-.441-2.941-1.154.155-.712.755-2.509.755-2.509l1.537.447z",
    fill: "url(#CEPimage_svg__paint9_linear_96_7675)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.965 193.294l-.39 2.818s-1 .351-1.671-.068l-.28-3.093 2.341.343z",
    fill: "url(#CEPimage_svg__paint10_linear_96_7675)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.232 193.29l-.737 1.168a1.388 1.388 0 00-.171 1.093c.254.973.762 2.87.985 3.365.303.674 4.388 1.083 4.388 1.083s.366-.507-.482-1.124c-.847-.616-1.392-.714-1.689-1.621-.297-.907-.49-3.472-.49-3.472l-1.804-.492z",
    fill: "url(#CEPimage_svg__paint11_linear_96_7675)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.296 190.325c-.27.212-1.59 4.16-1.59 4.16s-.39.499-1.232-.259c-.328-.294-.365-.358-.365-.358l.162-3.886 3.025.343z",
    fill: "url(#CEPimage_svg__paint12_linear_96_7675)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.576 136.645a305.303 305.303 0 01-3.325 57.676 27.637 27.637 0 01-2.74-.056 69.596 69.596 0 01-3.936-16.121c-1.193-9.531.234-10.358-.736-17.422-.858-6.256-2.1-6.503-3.538-15.385-1.56-9.637-.377-11.08.197-11.601 2.445-2.22 8.17-.693 14.078 2.909z",
    fill: "url(#CEPimage_svg__paint13_linear_96_7675)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42.498 133.733c2.332-2.114 7.65-.818 13.262 2.431-6.483 6.914-7.198 11.408-6.43 14.325.868 3.299 3.53 4.254 3.51 7.86-.023 4.429-4.056 5.593-3.982 10.281.05 3.1 1.82 3.072 2.23 6.905.483 4.531-1.834 6.086-1.093 9.439.32 1.442 1.234 3.329 3.85 5.276a358.46 358.46 0 01-.592 4.074 27.637 27.637 0 01-2.74-.056 69.596 69.596 0 01-2.321-7.428 70.788 70.788 0 01-1.617-8.696c-1.193-9.531.234-10.358-.736-17.422-.858-6.256-2.1-6.503-3.538-15.385-1.56-9.641-.377-11.083.197-11.604z",
    fill: "#000",
    opacity: 0.25
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.572 136.492a188.213 188.213 0 00-26.237 55.363 3.43 3.43 0 01-1.864.282A3.473 3.473 0 0122.363 191a53.969 53.969 0 01-.452-13.415c.197-2.135.543-5.69 1.926-10.077 1.548-4.914 2.605-5.188 4.623-10.386 2.094-5.396 1.593-6.744 3.603-13.498a88.66 88.66 0 014.48-11.833l16.03 4.701z",
    fill: "url(#CEPimage_svg__paint14_linear_96_7675)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.265 125.111c-.053 1.963-3.305 3.692-5.924 4.222-6.122 1.241-13.22-3.173-16.587-8.055-.662-.955-1.397-2.121-1.574-2.031-.4.203 3.28 6.203 4.876 13.026.814 3.491.603 5.126 2.13 7.45.345.527.771 1.075.621 1.698-.375 1.559-3.97 1.965-6.465 2.245-2.633.294-5.09.268-7.517.233-3.886-.056-4.192-.256-5.08.176-2.702 1.315-2.517 4.469-4.553 4.889-1.709.354-3.441-1.542-3.99-2.139-2.857-3.118-2.704-6.879-3.21-10.671-1.178-8.816-6.007-18.479-10.731-24.594-1.432-1.855-2.43-2.831-2.491-4.555-.182-5.06 7.898-10.645 14.625-11.287 1.845-.176 5.147-.121 8.243.168 1.236.116 2.553.286 3.97.532 3.433.596 5.823 1.01 8.259 2.117 9.823 4.458 7.68 14.382 18.31 21.245 3.654 2.36 7.144 3.276 7.088 5.331z",
    fill: "url(#CEPimage_svg__paint15_linear_96_7675)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.019 90.469s-.422 2.336-1.393 3.998c-.878 1.503-4.507 2.042-5.263 2.303-.756.262 1.141 1.568 3.158 2.042 2.016.473 7.916.783 9.071.152 1.156-.63-.75-.822-2.137-1.546-1.388-.724-1.852-3.666-1.423-4.917.429-1.25-2.013-2.032-2.013-2.032z",
    fill: "url(#CEPimage_svg__paint16_linear_96_7675)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M38.853 89.793c1.464-1.037 1.87-3.843 1.056-4.474-.232-.18-.454-.097-3.757 1.218-1.64.653-2.444 1-2.713 1.718-.162.441-.136 1.029.043 1.5.093.24.273.538.672 1.11.355.506.331.488.44.636.261.353.765.95 1.689 1.639.062-.317.152-.627.269-.928.15-.391.351-.761.597-1.102.576-.763 1.23-.98 1.704-1.317z",
    fill: "url(#CEPimage_svg__paint17_linear_96_7675)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 92.462s.958 1.415 2.731 1.223c1.588-.172 1.665-3.725.615-4.433-.35-.236-1.037-.31-1.58-.133-.324.105-.428.244-.958.405-.489.147-.631.1-.775.232-.18.164-.297.552.058 1.575-.317-.294-.688-.394-.94-.261a.532.532 0 00-.203.214c-.205.414.19.912 1.052 1.178z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.677 124.812c-4.443-.992-6.208-.96-8.404-2.718-3.654-2.921-4.204-7.368-6.327-7.313-1.005.025-1.82 1.043-2.4 2.038l1.604 2.493c0-.032.01-.057.027-.066.178-.089.912 1.073 1.574 2.031 3.37 4.882 10.468 9.296 16.587 8.056 1.756-.356 3.792-1.249 4.962-2.393a76.123 76.123 0 00-7.623-2.128z",
    fill: "#B20422",
    opacity: 0.3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.96 141.74c-2.69.238-8.743.347-13.025-3.582-7.128-6.543-3.592-18.995-1.111-24.35 2.845-6.14 7.373-9.577 10.124-11.666 3.414-2.591 5.497-4.173 8.005-3.82 6.483.917 10.972 14.098 7.413 17.873-1.164 1.235-2.319.535-5.69 1.6-1.098.348-9.294 2.939-10.721 8.926-1 4.191 1.544 9.098 6.072 12.394-.358.875-.714 1.75-1.067 2.625z",
    fill: "url(#CEPimage_svg__paint18_linear_96_7675)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.103 139.57c-3.045-1.91-3.495-3.845-6.905-5.151-4.429-1.699-6.558.459-8.753-1.283-2.614-2.073-.3-5.684-2.256-11.951-.332-1.063-2.853-9.142-8.638-10.172-2.697-.479-6.26.546-7.633 2.814-1.075 1.774-.074 3.098-1.38 5.057-1.306 1.959-2.867 1.479-4.531 3.112-2.643 2.593-3.048 8.061-.662 11.154 1.11 1.442 2.558 2.013 5.28 3.085a25.73 25.73 0 004.537 1.323c-3.333-3.172-5.06-7.263-4.21-10.837.89-3.733 4.41-6.144 7.2-7.516 2.794 5.216 5.077 11.256 5.836 16.949.507 3.792.354 7.553 3.21 10.671.55.6 2.283 2.493 3.99 2.139 2.035-.42 1.852-3.573 4.555-4.889.889-.432 1.193-.232 5.08-.176 2.427.036 4.887.064 7.517-.233 2.221-.249 5.301-.6 6.22-1.771-4.003-.108-6.675-1.209-8.457-2.325z",
    fill: "#B20422",
    opacity: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.724 143.838l-.313-.914c-.5-1.458.321-3.012 1.832-3.47l59.267-17.909 1.806 6.072-58.968 18.017c-1.503.46-3.127-.343-3.624-1.796z",
    fill: "url(#CEPimage_svg__paint19_linear_96_7675)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M119.348 145.877c-16.98 5.459-35.174-4.087-40.481-21.781-5.434-18.12 4.805-37.342 22.688-42.45 17.561-5.016 35.318 5.687 39.849 23.447 4.428 17.355-5.371 35.419-22.056 40.784zm-1.371-4.947c14.089-4.491 22.347-19.735 18.566-34.36-3.856-14.912-18.799-23.821-33.507-19.576-14.934 4.31-23.501 20.371-19.01 35.534 4.401 14.866 19.653 22.96 33.951 18.402z",
    fill: "url(#CEPimage_svg__paint20_linear_96_7675)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M82.51 121.544l-7.553 2.283c-.518 2.391-1.526 3.761-2.541 4.596-3.817 3.139-8.914-.285-16.024 3.396-3.569 1.847-2.888 3.022-6.235 4.31-5.53 2.131-8.061-.82-12.954 1.119-4.95 1.962-5.438 6.201-8.245 6.049-1.201-.065-2.747-.932-4.471-4.218l-1.24.374c-1.511.457-2.332 2.012-1.832 3.47l.313.915c.497 1.453 2.121 2.256 3.624 1.796l58.968-18.018-1.81-6.072z",
    fill: "#D8DEE8",
    opacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M119.376 143.361c-14.789 4.721-30.582-3.64-35.144-19.026-4.665-15.703 4.21-32.34 19.682-36.797 15.228-4.387 30.687 4.849 34.668 20.281 3.901 15.129-4.639 30.891-19.206 35.542z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M120.496 147.4c-16.979 5.459-35.174-4.086-40.481-21.781-5.434-18.119 4.805-37.342 22.688-42.45 17.561-5.016 35.318 5.687 39.849 23.446 4.429 17.356-5.372 35.42-22.056 40.785zm-1.371-4.947c14.089-4.491 22.348-19.735 18.566-34.36-3.856-14.913-18.799-23.821-33.507-19.576-14.933 4.31-23.501 20.37-19.01 35.535 4.401 14.864 19.653 22.958 33.951 18.401z",
    fill: "url(#CEPimage_svg__paint21_linear_96_7675)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M120.012 145.654c-16.033 5.142-33.186-3.893-38.17-20.59-5.096-17.072 4.55-35.173 21.386-40 16.55-4.744 33.313 5.321 37.607 22.073 4.203 16.392-5.053 33.462-20.823 38.517zm-.889-3.201c14.09-4.491 22.348-19.735 18.566-34.36-3.856-14.913-18.798-23.821-33.507-19.576-14.933 4.31-23.5 20.37-19.01 35.535 4.403 14.864 19.655 22.958 33.953 18.401h-.002z",
    fill: "url(#CEPimage_svg__paint22_linear_96_7675)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M20.186 141.178l.599-1.477s.978.059 1.777-.514c.437-.311 1.213-.404 1.439-.342.225.062 1.077.025.106.485-.97.46-.962.801-.558 1.175.404.375 1.944 1.189 2.498 1.228.555.039-.444.889-1.007.997-.563.109-1.475.247-2.608-.416-.412-.239-2.246-1.136-2.246-1.136z",
    fill: "url(#CEPimage_svg__paint23_linear_96_7675)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M73.907 128.596s2.505-.247 3.999-.881c1.493-.635 2.457.276 2.32.906s-2.592 1.506-3.574 1.538c-.982.031-2.745-1.563-2.745-1.563z",
    fill: "url(#CEPimage_svg__paint24_linear_96_7675)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint0_linear_96_7675",
    x1: 180.955,
    y1: 20.329,
    x2: 70.038,
    y2: 159.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint1_linear_96_7675",
    x1: 135.863,
    y1: 116.669,
    x2: 188.839,
    y2: 76.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint2_linear_96_7675",
    x1: 101.73,
    y1: 139.648,
    x2: 178.321,
    y2: 135.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint3_linear_96_7675",
    x1: 48.84,
    y1: 45.846,
    x2: 226.688,
    y2: 323.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint4_linear_96_7675",
    x1: 139.623,
    y1: 161.221,
    x2: 67.678,
    y2: 258.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint5_linear_96_7675",
    x1: 141.864,
    y1: 130.341,
    x2: 124.744,
    y2: 165.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint6_linear_96_7675",
    x1: 141.32,
    y1: 164.556,
    x2: 153.073,
    y2: 164.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint7_linear_96_7675",
    x1: 153.073,
    y1: 174.447,
    x2: 164.687,
    y2: 174.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint8_linear_96_7675",
    x1: 140.498,
    y1: 161.118,
    x2: 68.256,
    y2: 259.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint9_linear_96_7675",
    x1: 56.349,
    y1: 186.346,
    x2: 54.805,
    y2: 206.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint10_linear_96_7675",
    x1: 52.3,
    y1: 197.371,
    x2: 52.58,
    y2: 176.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint11_linear_96_7675",
    x1: 26.708,
    y1: 184.036,
    x2: 25.165,
    y2: 203.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint12_linear_96_7675",
    x1: 25.197,
    y1: 196.978,
    x2: 25.477,
    y2: 176.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint13_linear_96_7675",
    x1: 34.323,
    y1: 105.762,
    x2: 55.949,
    y2: 174.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint14_linear_96_7675",
    x1: 8.27,
    y1: 143.424,
    x2: 35.302,
    y2: 162.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint15_linear_96_7675",
    x1: 1.077,
    y1: 100.542,
    x2: 79.553,
    y2: 145.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint16_linear_96_7675",
    x1: 39.11,
    y1: 87.392,
    x2: 34.692,
    y2: 97.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint17_linear_96_7675",
    x1: 33.126,
    y1: 100.028,
    x2: 37.639,
    y2: 86.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint18_linear_96_7675",
    x1: -3.051,
    y1: 107.704,
    x2: 75.424,
    y2: 152.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint19_linear_96_7675",
    x1: 84.316,
    y1: 133.654,
    x2: 21.264,
    y2: 133.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint20_linear_96_7675",
    x1: 142.467,
    y1: 113.909,
    x2: 77.41,
    y2: 113.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint21_linear_96_7675",
    x1: 118.728,
    y1: 150.232,
    x2: 108.42,
    y2: 102.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint22_linear_96_7675",
    x1: 103.162,
    y1: 80.475,
    x2: 117.549,
    y2: 144.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint23_linear_96_7675",
    x1: 20.186,
    y1: 140.828,
    x2: 26.212,
    y2: 140.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CEPimage_svg__paint24_linear_96_7675",
    x1: 73.907,
    y1: 128.831,
    x2: 80.237,
    y2: 128.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "CEPimage_svg__clip0_96_7675"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h200v200H0z"
  })))));
}

export default SvgCePimage;